import {onMounted, onBeforeUnmount} from 'vue';
import type {Events} from '~/lib/events';
import {eventBus} from '~/lib/events';

export function useEvent(eventName: keyof Events, listener: () => void) {
    onMounted(() => {
        eventBus.on(eventName, listener);
    });

    onBeforeUnmount(() => {
        eventBus.off(eventName, listener);
    });
}
